import { type Dispatch } from '@reduxjs/toolkit';
import { AutomationStatus } from '@repo/utils';
import { CaseUtil } from '@vectord/utils';
import nodeService from 'automations/services/nodeService';
import { type RootState } from 'automations/store';
import { swapNodeId } from 'automations/store/reactFlowSlice';
import { type TriggerNodeType } from 'automations/types/nodeTypes';

import { NodeError } from './nodeError';

export const saveTriggerNode = (nodeId: string, automationId: string, mode: 'create' | 'edit' = 'create') => async (
  dispatch: Dispatch<any>,
  getState: () => RootState,
) => {
  const allNodes = getState().automations.flowNodes.nodes;
  const currentNode = allNodes.find((node) => node.id === nodeId) as TriggerNodeType;
  if (!currentNode) return null;

  const status = getState().automations.automationConfig.automationData?.status;

  const { additionalOptions } = currentNode.data;

  const parsedAdditionalOptions = CaseUtil.toCase('snakeCase', additionalOptions);

  let response;
  if (mode === 'create') {
    if (status !== AutomationStatus.draft) {
      throw new NodeError('You are not allowed to save a trigger node in this state');
    } else {
      response = await dispatch(nodeService.endpoints.saveTriggerNode.initiate({
        id: automationId,
        triggerType: currentNode.data.nodeSubType,
        additionalOptions: parsedAdditionalOptions,
      }));
    }
  } else {
    if (status === AutomationStatus.published) {
      throw new NodeError('You are not allowed to edit a trigger node in this state');
    }
    response = await dispatch<any>(nodeService.endpoints.updateNode.initiate({
      id: nodeId,
      additionalOptions: parsedAdditionalOptions,
    }));
  }

  if (response.error) {
    throw response.error;
  }
  if (response.data?.node.id) {
    // update the new node id in store
    dispatch(swapNodeId({ oldNodeId: nodeId, newNodeId: response.data?.node.id }));
  }
  return response.data;
};
